import { useQuery } from '@tanstack/react-query';

import { SearchParams } from '@/entities/SearchParams';
import { divisionKeys } from '@/hooks/divisions/divisionKeys';
import { getLeagueDivisionsController } from '@/interface-adapters/controllers/leagues/get-league-divisions.controller';
import { useOrganizationStore } from '@/store/organization-store';

export const useLeagueDivisionsQuery = (teamLeagueUuid: string, searchParams: SearchParams) => {
	const store = useOrganizationStore();
	return useQuery({
		queryKey: divisionKeys.leagueDivisions(store.organizationUuid, teamLeagueUuid, JSON.stringify(searchParams)),
		queryFn: () => getLeagueDivisionsController(teamLeagueUuid, store.organizationUuid, searchParams),
		enabled: !!(store.organizationUuid && teamLeagueUuid)
	});
};
